// extracted by mini-css-extract-plugin
export var loadingSpinner = "_27-0";
export var spinnerContainer = "_27-1";